var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble1Cyan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40",
    "data-name": "Group 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 426.603,
    height: 423.913,
    viewBox: "0 0 426.603 423.913",
    fill: "#298FC2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 426.603,
    height: 423.913,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M261,6.33C199.145-10.57,126.491,7.588,76.93,46.3,1.64,105.1-19.737,214.483,18.785,300.415c38.492,85.867,136.94,135.061,229.072,121.166,92.6-13.964,165.391-95.255,177.242-186.979C437.221,140.794,375.5,29.49,261,6.33M393.417,256.272C364.16,363.818,250.6,423.288,145.691,386.907,33.629,348.047-10.423,212.821,47.034,111.621,93.771,29.3,184.706,11.4,269.18,27.415c49.209,18.392,72.714,41.657,98.27,78.986,30.079,43.929,39.972,98.388,25.966,149.872",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M138.451,39.9c-16.147-5.524-36.859,5.049-49.8,14.363C74.443,64.491,63.3,77.614,63.951,95.707a2.288,2.288,0,0,0,3.855,1.6c11.24-9.91,20.138-22.434,32.376-31.21,12.281-8.807,26.629-9.983,39.487-16.875,4.094-2.193,2.722-7.971-1.218-9.319",
    transform: "translate(35.013 21.02)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble1Cyan);
export default __webpack_public_path__ + "static/media/bubble-1-cyan.2b1c69e90555add27e0ade377ce3ecaf.svg";
export { ForwardRef as ReactComponent };